var StickerCreator = require('../../creators/sticker');

module.exports = {
  setCheckOnce: function () {
    return !window.Android
      && this.appBridge.version.isApp('desygner')
      && this.appBridge.version.isEqual('1.1.3');
  },

  set: function (data) {
    if (!this.stickerCreator) {
      this.stickerCreator = new StickerCreator();
      this.stickerCreator.initialize();
    }

    this.stickerCreator.create(data);
  }
};
